import { FeedbackFormData, QuestionType } from './interfaces';
import { AnalyticsType } from '@interfaces/analytics';

export const feedbackFormData: FeedbackFormData = {
  id: 'mira-journey-feedback',
  formTitle: 'Tell us about your MIRA Journey',
  steps: [
    {
      id: 'overall-rating',
      type: QuestionType.HAPPINESS,
      title: 'How would you rate the MIRA experience overall?',
    },
    {
      id: 'valuable-parts',
      type: QuestionType.SELECT,
      title: 'What parts of the MIRA experience did you find most valuable?',
      subtitle: 'You can mark multiple options that make an impact.',
      options: [
        { id: 'learning-dubai', text: 'Learning about Dubai' },
        {
          id: 'office-hours',
          text: 'The ability to meet/join office hour sessions with onboarding coordinators',
        },
        {
          id: 'avatar-customization',
          text: 'Creating and customizing my avatar',
        },
        { id: 'engaging-joiners', text: 'Engaging with other joiners' },
        {
          id: 'company-culture',
          text: 'Information about company and culture via interactive content',
        },
        { id: 'shareable-moments', text: 'Shareable moments' },
        { id: 'sense-belonging', text: 'Feeling a sense of belonging' },
      ],
      multiselect: true,
    },
    {
      id: 'navigation-ease',
      analyticsKey: AnalyticsType.FeedbackSurveyAnswer,
      type: QuestionType.RATE,
      title: 'How easy was it to navigate the experience?',
      subtitle: 'From 1 = very hard to 5 = very easy',
      minValue: 1,
      maxValue: 5,
    },
    {
      id: 'revisit-likelihood',
      type: QuestionType.RATE,
      title: 'How likely are you to revisit the MIRA experience again?',
      subtitle: 'From 1 = Not likely to 5 = Absolutely',
      minValue: 1,
      maxValue: 5,
      analyticsKey: AnalyticsType.FeedbackSurveyAnswer,
    },
    {
      id: 'improvements',
      type: QuestionType.TEXTAREA,
      title: 'What can we do to improve the experience?',
      placeholder: 'Type your suggestions here',
      maxLength: 1000,
    },
  ],
};

export const officeHoursFeedbackFormData: FeedbackFormData = {
  id: 'office-hours-feedback',
  formTitle: 'Tell us about your Office Hours session',
  steps: [
    {
      id: 'session-usefulness',
      type: QuestionType.HAPPINESS,
      title: 'How useful did you find this session?',
    },
    {
      id: 'recommend-likelihood',
      type: QuestionType.RATE,
      title: 'How likely are you to recommend Office Hours to other new joiners',
      subtitle: 'From 1 = never recommend to 5 = definitely recommend',
      minValue: 1,
      maxValue: 5,
    },
    {
      id: 'session-improvements',
      type: QuestionType.TEXTAREA,
      title: 'What can we do to improve these sessions?',
      placeholder: 'Type your suggestions here',
      maxLength: 1000,
    },
  ],
};
